import vEmits from "@/utils/vEmits";
const state = {

    state: '',
    /*
       playing 正在播放
       pause 暂停
       loading 加载等待
    */
    currentTime:'00:00',
    duration:'00:00',
    dTime:0,

    buffered:'0%',
    perPlay:'0%',
    volume:0.8,

    audio:[{}],
    songDat:[{}]

}

const getters = {

    dmSet:(state,getters,params) => {
        return state.audio[0];
    }

}

const mutations = {

   mediaSet(state,mediaDat){
        if(mediaDat.key == 'audio' || mediaDat.key == 'songDat'){
            state[mediaDat.key].splice(0,1,mediaDat.val);
        }else{
            state[mediaDat.key] = mediaDat.val;
        }

   },

   MplayClean(state){
        state.state = '';
        state.currentTime = '00:00';
        state.duration = '00:00';
        state.dTime = 0;
        state.buffered = '0%';
        state.perPlay = '0%';
        state.volume = 0.8;
        state.songDat.splice(0,1,[]);
   }

}

const actions = {

    playStateSet({commit,state},setDat){
        commit('mediaSet',setDat)
    },

    AplayClean({commit,state}){
        commit('MplayClean')
    },
}

export default {
    namespaced:true,
    state,
    getters,
    mutations,
    actions
}
